import { type Format } from '@ugin/shared';

export const queryKeys = {
  health: () => ['health'] as const,
  decks: {
    all: () => ['decks'] as const,
    list: (format?: Format) => ['decks', 'list', { format: format ?? 'all' }] as const,
    detail: (id: string) => ['decks', 'detail', id] as const,
    analysis: (id: string) => ['decks', 'analysis', id] as const,
    similar: (id: string) => ['decks', 'similar', id] as const,
  },
  meta: {
    forFormat: (format: Format) => ['meta', format] as const,
  },
  archetypes: {
    forFormat: (format: Format) => ['archetypes', format] as const,
  },
  matches: {
    all: () => ['matches'] as const,
    list: (params: { format?: Format; deckId?: string; limit?: number; offset?: number }) =>
      ['matches', 'list', params] as const,
    detail: (id: string) => ['matches', 'detail', id] as const,
  },
  stats: {
    overview: (format?: Format) => ['stats', { format: format ?? 'all' }] as const,
  },
  matchups: {
    list: (params: { format?: Format; deckId?: string }) => ['matchups', params] as const,
  },
  logs: {
    recent: (limit: number) => ['logs', 'recent', limit] as const,
  },
} as const;
